export type ICreatedAt = { createdAt: string };

export function sortDescByCreatedAt(a: ICreatedAt, b: ICreatedAt): number {
  return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
}
